import getClassNameReduxUtil from '@gymaholic/packages/src/modules/redux/utils/get-class-name/index.js'
import { logUtil } from 'packages/src'
import getIdReduxUtil from 'modules/redux/utils/get-id/index.js'
import { EXERCISE_CLASS_NAME } from '@gymaholic/packages'
import getVideoExerciseSchemaUtil from 'modules/exercise/redux/utils/get-video-schema/index.js'

const CLASS_NAME_TO_SCHEMA_GETTER = {
  [EXERCISE_CLASS_NAME]: getVideoExerciseSchemaUtil
}

/**
 * @param props
 * @param props.instance
 * @param props.state
 * @param props.intl
 */
export default function getSchemaUtil (props) {
  const {
    instance,
    state,
    intl
  } = props

  const id = getIdReduxUtil(instance)
  const className = getClassNameReduxUtil(instance)

  const logPrefix = `id=${id} className=${className}`
  logUtil('getSchemaUtil').debug(`${logPrefix} [start]`)

  if (!className) {
    logUtil('getSchemaUtil').warn(`${logPrefix} [noop] no className`)
    return null
  }

  const getter = CLASS_NAME_TO_SCHEMA_GETTER[className]
  if (!getter) {
    logUtil('getSchemaUtil').debug(`${logPrefix} [noop] no getter`)
    return null
  }

  return getter({
    instance,
    state,
    intl
  })
}
